import { useEffect, useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_SAL3010_R01 } from "./Content_SAL3010_R01";
import { Info_SAL3010_R01 } from "./Info_SAL3010_R01";
import { SearchSection_SAL3010_R01 } from "./SearchSection_SAL3010_R01";
import { useSAL3010_R01Store } from "./Store_SAL3010_R01";
import { Table_SAL3010_R01 } from "./Table_SAL3010_R01";
import { AgGridReact } from "ag-grid-react";
import { SAL3010_R01DetailDto, SAL3010_R01Dto, SAL3010_R01HeaderDto } from "./Dto_SAL3010_R01";


export const Container_SAL3010_R01 = () => {

	const { 
		allCount,
		initData, 
		SAL3010_R01List,
		SAL3010_R01DetailList,
	} = useSAL3010_R01Store();

	
	const { moneyCdList, vatTypeList } = useCommonCodeStore();
	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'SAL3010_R01',
		type: 'height',
		storageKey: 'SAL3010_R01-split-height',
		min: 5,
		max: 80,
		default: 40
	} as const;
	const gridRef = useRef<AgGridReact<SAL3010_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<SAL3010_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		handleExcelClick,
		fetchData,
		defaultSAL3010_R01HeaderRow,
		defaultSAL3010_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_SAL3010_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,		
	});

	useEffect(() => { handleCreateClick(); }, []);

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_SAL3010_R01 />

		<div className="flex-1 flex flex-col p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="w-full" style={{ height: `${splitValue}%` }} ref={infoRef}>
				<Info_SAL3010_R01
					defaultSAL3010_R01HeaderRow={defaultSAL3010_R01HeaderRow()}
				/>
			</div>
			<div
				className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('UD', e.nativeEvent)}
				onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
				data-comment="리사이저"
			/>
			<div className="w-full" style={{ height: `${100 - splitValue}%` }}>
				<Table_SAL3010_R01 gridRef={gridRef} defaultSAL3010_R01HeaderRow={defaultSAL3010_R01HeaderRow()} handleCreateClick={handleCreateClick} />
			</div>
		</div>
		<Message />
	</div>
}